var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { CancellationReason } from '../enums/cancellation-reason.enum.js';
/**
 * Body for the patient self-service withdrawal endpoint
 * (`POST /users/:userId/appointments/withdraw`, TM-9436 / #1334).
 *
 * `appointmentRef` is either a real appointment id (UUID) or a virtual series
 * occurrence reference (`virtual:<seriesId>:<occurrenceKey>`). It travels in the
 * body rather than the path because the virtual ref contains colons. Virtual
 * refs are materialized before cancellation.
 *
 * `reason` is optional and drawn from a fixed set — skipping it never blocks the
 * cancellation. There is no free-text field on purpose. The withdrawal always
 * writes `origin=PATIENT` server-side; the client does not choose the origin.
 */
export class WithdrawFromAppointmentDto {
    appointmentRef;
    reason;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WithdrawFromAppointmentDto.prototype, "appointmentRef", void 0);
__decorate([
    IsOptional(),
    IsEnum(CancellationReason),
    __metadata("design:type", String)
], WithdrawFromAppointmentDto.prototype, "reason", void 0);
//# sourceMappingURL=withdraw-from-appointment.dto.js.map